export default "__VITE_PUBLIC_ASSET__aa585b84__"